import { cdn } from "../../../helpers/cdn";

export default {
  newDesign: true,
  parameters: {
    segment: 4,
    landing_id: "IdQV",
  },
  downtimeUrl: "https://www.kodland.org/id",
  title: "Di balik setiap video keren ada kreator yang hebat | Kodland",
  startPage: {
    title: "Di balik setiap video keren ada kreator yang hebat",
    subtitle:
      "Jawablah 5 pertanyaan dan dapatkan pelajaran GRATIS untuk anak anda",
    button: "Terima 🚀",
    backgroundColor: "#fff",
    image: {
      url: cdn("indonesia_video_desk_2.gif"),
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: cdn("indonesia_video_mob_2.gif"),
      style: {
        width: "100%",
      },
    },
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Terima kasih atas kepercayaan Anda pada platform pendidikan kami!",
    subtitle:
      "Sayangnya, tablet atau ponsel tidak sesuai untuk mengikuti pelajaran kami. Kami akan sangat senang melihat Anda di kelas berikutnya!",
  },
  quizRotateBySteps: {
    1: {
      question: "Bagaimana biasanya anak Anda menghabiskan waktu luangnya?",
      answers: [
        "📱 Bermain game di HP atau komputer",
        "🎬 Menonton atau membuat video",
        "🎨 Menggambar atau membuat konten kreatif",
        "😊 Menghabiskan waktunya dengan keluarga",
        "👥 Menghabiskan waktunya dengan teman",
        "🏃 Bermain kegiatan olahraga",
      ],
    },
    2: {
      question:
        "Apakah anak Anda mengikuti kegiatan ekstrakurikuler di luar pembelajaran sekolah?",
      answers: [
        "📚 Kelas yang membantu untuk meningkatkan nilai pembelajara",
        "🏃 Ya. Kegiatan olahraga",
        "🎨 Ya. Kelas seni",
        "🎬 Ya. Kelas desain, animasi, atau video editing",
        "🏕️ Ya. Pramuka",
        "✖️ Tidak. Anak tidak memiliki waktu untuk itu",
      ],
    },
    3: {
      title: "Berapa usia anak Anda?",
      type: "age",
      subtitle:
        "Kami akan memilih kursus yang paling sesuai dengan usia anak Anda.",
      button: "",
    },
    4: {
      question:
        "Untuk mengikuti kelas gratis ini, Anda perlu menggunakan komputer atau laptop (bukan HP) dengan koneksi internet stabil. Apakah Anda memiliki komputer/laptop di rumah?",
      answers: [
        "💻 Ya, kami memiliki komputer/laptop di rumah",
        {
          answer: "❌ Tidak, kami tidak memiliki komputer/laptop di rumah",
          stopAnswer: true,
        },
      ],
    },
    5: {
      title: "Tinggal satu langkah lagi 🎉",
      typeInfo: "congrats",
      subtitle:
        "Buka potensi kreatif anak Anda dalam coding dan kreativitas digital! 📅 Jadwalkan kelas",
      button: "📆 Pesan",
    },
    6: {
      title: "Daftar untuk kelas uji coba gratis",
      type: "one-page-contacts",
      subtitle:
        "Mari saling mengenal, cari tahu apa saja yang akan kita pelajari, dan seperti apa proses belajarnya nanti.",
      button: "Lanjutkan 🔥",
    },
    7: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    8: {
      title: "Tinjau detail berikut untuk menyelesaikan pendaftaran ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Harap diperhatikan bahwa Anda akan membutuhkan komputer atau laptop yang berfungsi untuk pelajaran, dan Anda harus menemani anak Anda selama kelas berlangsung. Mohon diingat bahwa pelajaran ini bersifat individual dan personal.",
      button: "Selanjutnya bagaimana?",
    },
    9: {
      title: "Sebelum kelas uji coba, periksa email dan WhatsApp Anda 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Kami akan mengirimkan pengingat 24 jam sebelum kelas dimulai dan meminta Anda untuk mengonfirmasikan kehadiran Anda 2 jam sebelum kelas dimulai. Sangat penting untuk tetap berkomunikasi agar kelas tidak dibatalkan.",
      button: "Selanjutnya bagaimana?",
    },
    10: {
      title: "Kelas akan diadakan di platform kami 💻",
      typeInfo: "classroom",
      subtitle:
        "Anda akan menerima tautan dan kode unik melalui WhatsApp dan email. Klik saja tautannya, dan Anda akan langsung diarahkan ke kelas. Tidak perlu aplikasi tambahan, tidak perlu mengunduh apa pun.",
      button: "Mengerti ✅",
    },
  },
};
